// ─────────────────────────────────────────────────────────────────
// Glass-i — Glass Type Routing page helpers (Stage WO-2A).
// Pure, unit-testable. The matrix state is { [glassType]: string[] }
// (the set of execution_group codes that type visits).
// ─────────────────────────────────────────────────────────────────

// Build the editable selection state from the /matrix payload.
export function buildSelections(matrix) {
  const out = {};
  const sel = (matrix && matrix.selections) || {};
  const types = (matrix && matrix.glassTypes) || [];
  for (const t of types) {
    const code = t.glassType || t;
    out[code] = Array.from(new Set(sel[code] || []));
  }
  return out;
}

// Toggle one (glassType, stage) cell → a NEW selections object.
export function toggleStage(selections, glassType, group) {
  const cur = new Set(selections[glassType] || []);
  if (cur.has(group)) cur.delete(group); else cur.add(group);
  return { ...selections, [glassType]: Array.from(cur) };
}

export function hasStage(selections, glassType, group) {
  const arr = selections[glassType];
  return Array.isArray(arr) && arr.includes(group);
}

// Set every stage for a type on/off at once (row toolbar convenience).
export function setAllStages(selections, glassType, allGroups, on) {
  return { ...selections, [glassType]: on ? [...allGroups] : [] };
}

// Deep-ish equality per type (order-insensitive) → dirty detection.
export function isDirty(current, original) {
  const keys = new Set([...Object.keys(current || {}), ...Object.keys(original || {})]);
  for (const k of keys) {
    const a = new Set((current && current[k]) || []);
    const b = new Set((original && original[k]) || []);
    if (a.size !== b.size) return true;
    for (const v of a) if (!b.has(v)) return true;
  }
  return false;
}

// Only the changed types → a smaller bulk-save payload.
export function changedSelections(current, original) {
  const out = {};
  for (const k of Object.keys(current || {})) {
    const a = new Set(current[k] || []);
    const b = new Set((original && original[k]) || []);
    let diff = a.size !== b.size;
    if (!diff) for (const v of a) if (!b.has(v)) { diff = true; break; }
    if (diff) out[k] = Array.from(a);
  }
  return out;
}

// Types with zero configured stages (Release would block these).
export function unconfiguredTypes(selections) {
  return Object.keys(selections || {}).filter((k) => !(selections[k] && selections[k].length));
}

// Case-insensitive substring filter over the type code.
export function matchesSearch(glassType, term) {
  if (!term) return true;
  return String(glassType || '').toLowerCase().includes(String(term).toLowerCase().trim());
}
